module.exports = __webpack_public_path__ + "img/collection.0b414699.png";